import { render, staticRenderFns } from "./LinksPage.vue?vue&type=template&id=572da79a&scoped=true"
import script from "./LinksPage.vue?vue&type=script&lang=js"
export * from "./LinksPage.vue?vue&type=script&lang=js"
import style0 from "./LinksPage.vue?vue&type=style&index=0&id=572da79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572da79a",
  null
  
)

export default component.exports